import { classnames, fDate, fNumber } from '@aibees/shared/utils';
import { CardContent, Divider, Typography } from '@mui/material';
import { memo } from 'react';
import { usePlanCardContext } from '../../../plan-card/context';
import { useCurrentSubscriptionApi } from '../../../price-and-plan/api/use-current-subscription-api';
import * as Styled from './styles';
import * as SX from './sx';
import type { DowngradeEffectProps as Props } from './types';

export const DowngradeEffect = memo(({ className }: Props) => {
  const { selectedPlan } = usePlanCardContext();
  const { data } = useCurrentSubscriptionApi();
  const currentPlan = data?.current?.plan;

  const lostCredit =
    Number(data?.credit?.total) -
    Number(selectedPlan?.metadata.rollover) +
    Number(selectedPlan?.metadata.request);

  const isDowngradingToFree = selectedPlan?.metadata.is_free === 'true';

  const isDowngradingToLowerPaid =
    !isDowngradingToFree &&
    (currentPlan?.interval === selectedPlan?.interval ||
      (currentPlan?.interval === 'MONTH' &&
        selectedPlan?.interval === 'YEAR')) &&
    Number(currentPlan?.metadata.request) >
      Number(selectedPlan?.metadata.request);

  return (
    <Styled.Wrapper
      className={classnames('DowngradeEffect', className)}
      sx={SX.root}
      variant="outlined"
    >
      <CardContent padding="normal" sx={SX.cardContent}>
        <Typography variant="body3" color="grey.700" fontWeight={500}>
          Effect of Downgrading
        </Typography>
        <Divider sx={SX.divider} />
        <Typography variant="body4" fontWeight={400} color="common.black">
          {isDowngradingToLowerPaid ? (
            <>{fNumber(lostCredit)} Credits will be lost.</>
          ) : (
            <>
              {fNumber(lostCredit)} Credits will be lost if not used until{' '}
              <Typography component="span" variant="body4" fontWeight={600}>
                {fDate(data?.current?.currentPeriodEnd)}
              </Typography>
            </>
          )}
        </Typography>
      </CardContent>
    </Styled.Wrapper>
  );
});

DowngradeEffect.displayName = 'DowngradeEffect';
